var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SignUpOrganizationBody',{attrs:{"bodyProp":_vm.bodyRight},scopedSlots:_vm._u([{key:"formSectionBody",fn:function(){return [(!_vm.getHasValidSession)?_c('div',[_c('SignIn')],1):_vm._e(),(_vm.getHasValidSession)?_c('div',{},[_c('RegisterUser')],1):_vm._e()]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }